import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
// import hotjar from '@hotjar/browser';
import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import './index.css';
import './vars.css';

import '@notablehealth/design-system/dist/index.css';
import '@xyflow/react/dist/style.css';

import { isDefined } from 'common';

import { App } from './App';

// const SITE_ID = 3388161 as const;
// const VERSION = 6 as const;
// const NONCE = 'convergence-of-riemannian-manifolds';
// hotjar.init(SITE_ID, VERSION, { nonce: NONCE });

declare global {
  interface Window {
    notableGitVersion: string;
  }
}
window.notableGitVersion = import.meta.env.VITE_GIT_SHA ?? 'dev';

if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://14e3faaeba39478b8699a1c43b19555f@o111996.ingest.sentry.io/4505132303056896',
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.01,
    release: `staff@${import.meta.env.VITE_GIT_SHA || 'dev'}`,
  });
}

const rootElement = document.getElementById('root');
if (!isDefined(rootElement)) {
  throw new Error('Failed to find root element');
}
createRoot(rootElement).render(<App />);
